/* ==========================================================================
   Kiro — Four Play Glossfinity quad: "exploded tower" story section
   File: assets/kiro-quad-gloss.js   (loaded by sections/kiro-quad-gloss.liquid)

   Self-contained version of the matte quad story for the Glossfinity pages:
   pins itself while scrolling, cross-fades the five points, drives the
   01–05 tabs and animates the Timeless Nude quad:

     0.00–0.32  the upright tower turns to a diagonal hero angle and grows;
                its four parts separate along the tower's axis (centre seam
                first, then the two outer seams)
     0.32–0.62  the exploded view keeps breathing and turning slowly
     0.62–0.94  parts close back together as the tower rotates upright
     0.94–1.00  locks into one; a glint runs over the caps
     throughout a soft halo behind the product drifts through the four shades
   ========================================================================== */
(function () {
  'use strict';

  if (window.KiroQuadGloss) return;

  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  var ease = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };   // easeInOutCubic
  var easeOut = function (t) { return 1 - Math.pow(1 - t, 3); };
  var win = function (p, a, b) { return clamp((p - a) / (b - a), 0, 1); };

  // ---- Product image ---------------------------------------------------------
  // Timeless Nude Glossfinity Quad product shot (764×1000). The CSS crops the
  // tower out of it, so this must stay this exact image.
  var DEFAULT_SRC = 'https://cdn.shopify.com/s/files/1/0089/0893/1152/files/Timeless_Nude_Glossfinity_quad_featured_image.png?width=764';

  // ---- Geometry (360×360 scene, rig origin at its centre) -------------------
  var ROWS = [0, 303, 448, 592, 756];                          // ring splits in the 756px source tower
  var TOWER_H = 340, TOWER_W = TOWER_H * 98 / 756;
  var TILT = 34;                                               // hero angle, degrees clockwise
  var GAP = 24;                                                // exploded gap between parts
  var OPEN_SCALE = 1.06;                                       // product grows a little as it opens
  var SEAM_DELAY = [0.18, 0, 0.18];                            // centre seam opens first

  var DEFAULT_SHADES = ['#b8604f', '#a65a46', '#bf6a64', '#9b3f37'];  // the four Timeless Nude shades

  function rgb(hex) { var n = parseInt(String(hex).replace('#', ''), 16); return [n >> 16, (n >> 8) & 255, n & 255]; }
  function mixRGB(a, b, t) { return a.map(function (v, i) { return Math.round(lerp(v, b[i], t)); }); }

  // How much of the screen fixed/sticky bars cover at the top (site header)
  // and bottom (e.g. an "Add to bag" bar), so the pinned story sits between them
  function fixedCover(root) {
    var vh = window.innerHeight, x = Math.round(window.innerWidth / 2), topCover = 0, bottomCover = 0;
    var probe = function (y, fn) {
      var stack = document.elementsFromPoint ? document.elementsFromPoint(x, y) : [];
      stack.forEach(function (el) {
        if (root.contains(el)) return;                        // ignore the section's own sticky pin
        for (var n = el; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
          if (n === root) return;
          var pos = getComputedStyle(n).position;
          if (pos === 'fixed' || pos === 'sticky') { fn(n.getBoundingClientRect()); return; }
        }
      });
    };
    probe(2, function (r) { if (r.bottom > topCover && r.bottom < vh * 0.4) topCover = r.bottom; });
    probe(vh - 2, function (r) { if (r.top > vh * 0.6 && vh - r.top > bottomCover) bottomCover = vh - r.top; });
    return { top: Math.round(topCover), bottom: Math.round(bottomCover) };
  }

  function init(root, cfg) {
    cfg = cfg || {};
    if (!root || root.__kqg) return null;
    var track = root.querySelector('.kqg-track');
    var pin = root.querySelector('.kqg-pin');
    var art = root.querySelector('.kqg-art');
    var reasons = [].slice.call(root.querySelectorAll('[data-kqg-reason]'));
    var tabs = [].slice.call(root.querySelectorAll('[data-kqg-tab]'));
    if (!track || !pin || !art || !reasons.length) return null;

    // Optional: move the story right after the product details
    if (cfg.placeAfter) {
      var anchor = document.querySelector(cfg.placeAfter);
      if (anchor && anchor.parentNode && anchor.nextElementSibling !== root && !anchor.contains(root)) {
        anchor.parentNode.insertBefore(root, anchor.nextSibling);
      }
    }

    var src = cfg.src || DEFAULT_SRC;
    var shades = DEFAULT_SHADES.map(function (d, i) {           // any missing or invalid colour falls back
      var s = cfg.shades && cfg.shades[i];
      return rgb(/^#?[0-9a-f]{6}$/i.test(String(s || '').trim()) ? String(s).trim() : d);
    });

    // ---- Build the product stage ----
    var stage = document.createElement('div');
    stage.className = 'kqg-stage';
    stage.setAttribute('aria-hidden', 'true');
    stage.innerHTML =
      '<div class="kqg-scene">' +
        '<div class="kqg-halo"></div>' +
        '<div class="kqg-floor"></div>' +
        '<div class="kqg-shadow"><div class="kqg-rig"></div></div>' +
      '</div>';
    var scene = stage.querySelector('.kqg-scene');
    var halo = stage.querySelector('.kqg-halo');
    var floor = stage.querySelector('.kqg-floor');
    var rig = stage.querySelector('.kqg-rig');

    var top = -TOWER_H / 2;
    var pieces = [0, 1, 2, 3].map(function (i) {
      var h = TOWER_H * (ROWS[i + 1] - ROWS[i]) / 756;
      var el = document.createElement('div');
      el.className = 'kqg-piece';
      el.setAttribute('data-i', i);
      el.style.width = TOWER_W + 'px';
      el.style.height = h + 'px';
      el.style.backgroundImage = 'url("' + src + '")';
      rig.appendChild(el);
      var pc = { el: el, h: h, y: top + h / 2 };
      top += h;
      return pc;
    });
    art.appendChild(stage);
    root.classList.add('kqg--on');
    root.__kqg = true;

    var reduced = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

    var coverKey = '';
    function measureCover() {
      var c = fixedCover(root), key = c.top + '/' + c.bottom;
      if (key === coverKey) return;
      coverKey = key;
      root.style.setProperty('--kqg-top', c.top + 'px');
      root.style.setProperty('--kqg-bottom', c.bottom + 'px');
    }
    function layout() {
      measureCover();
      var r = art.getBoundingClientRect();
      scene.style.setProperty('--kqg-fit', (Math.min(r.width, r.height) / 360 || 1).toFixed(4));
    }

    function progress() {
      var rect = track.getBoundingClientRect();
      var pinTop = parseFloat(getComputedStyle(pin).top) || 0;
      var travel = Math.max(1, track.offsetHeight - pin.offsetHeight);
      return clamp((pinTop - rect.top) / travel, 0, 1);
    }

    // ---- Copy + tabs (same feel as the theme's story) ----
    var activeIdx = -1;
    function renderCopy(p) {
      var n = reasons.length, t = p * (n - 1), r = Math.round(t);
      reasons.forEach(function (el, i) {
        var o = reduced.matches ? +(i === r) : clamp(1 - (Math.abs(t - i) - 0.08) / 0.34, 0, 1);
        el.style.opacity = String(o);
        el.style.transform = reduced.matches ? 'none' : 'translateY(' + ((i - t) * 70).toFixed(1) + 'px)';
        el.style.pointerEvents = i === r ? 'auto' : 'none';
      });
      if (r !== activeIdx) {
        activeIdx = r;
        reasons.forEach(function (el, i) { el.setAttribute('aria-hidden', String(i !== r)); });
        tabs.forEach(function (b, i) { b.setAttribute('aria-current', String(i === r)); });
      }
      tabs.forEach(function (b, i) { b.style.setProperty('--kqg-fill', clamp(p * n - i, 0, 1).toFixed(3)); });
    }

    // ---- Quad ----
    function renderQuad(p) {
      if (reduced.matches) p = 0.5;                           // reduced motion: one still, opened view

      var open = p < 0.5 ? ease(win(p, 0.06, 0.32)) : 1 - ease(win(p, 0.62, 0.94));
      var breath = 1 + 0.12 * Math.sin(Math.PI * win(p, 0.32, 0.62));
      var angle = p < 0.5
        ? TILT * ease(win(p, 0, 0.32)) + 4 * win(p, 0.32, 0.5)
        : (TILT + 4) * (1 - ease(win(p, 0.5, 0.94)));
      var scale = lerp(1, OPEN_SCALE, Math.min(1, angle / TILT)) *
        (1 + 0.012 * Math.exp(-Math.pow((p - 0.975) / 0.012, 2)));
      var lift = lerp(6, -6, p);

      rig.style.transform = 'translate3d(0,' + lift.toFixed(2) + 'px,0) rotate(' + angle.toFixed(3) + 'deg) scale(' + scale.toFixed(4) + ')';

      var gaps = SEAM_DELAY.map(function (d) { return GAP * breath * easeOut(clamp((open - d) / (1 - d), 0, 1)); });
      var total = gaps[0] + gaps[1] + gaps[2];
      var acc = 0;
      pieces.forEach(function (pc, i) {
        if (i > 0) acc += gaps[i - 1];
        var y = pc.y + acc - total / 2;
        pc.el.style.transform = 'translate3d(' + (-TOWER_W / 2).toFixed(2) + 'px,' + (y - pc.h / 2).toFixed(2) + 'px,0)';
      });

      var t = clamp(p, 0, 1) * (shades.length - 1), k = Math.min(shades.length - 2, Math.floor(t));
      var c = mixRGB(shades[k], shades[k + 1], ease(t - k));
      halo.style.setProperty('--kqg-halo', 'rgba(' + c.join(',') + ',0.30)');
      halo.style.setProperty('--kqg-halo-o', (0.55 + 0.45 * Math.max(open, win(p, 0, 0.1) * 0.6)).toFixed(3));

      floor.style.setProperty('--kqg-floor', (1 - Math.min(1, angle / 12)).toFixed(3));
      var glint = p < 0.5 ? win(p, 0, 0.1) : win(p, 0.9, 1);
      scene.style.setProperty('--kqg-glint', lerp(-60, 60, ease(glint)).toFixed(1) + '%');
    }

    // Tabs jump to their point
    tabs.forEach(function (b, i) {
      b.addEventListener('click', function () {
        var travel = Math.max(1, track.offsetHeight - pin.offsetHeight);
        var pinTop = parseFloat(getComputedStyle(pin).top) || 0;
        var y = track.getBoundingClientRect().top + window.pageYOffset - pinTop + travel * (i / (tabs.length - 1));
        window.scrollTo({ top: Math.round(y) + 1, behavior: reduced.matches ? 'auto' : 'smooth' });
      });
    });

    // Inertia for the quad; copy follows the scroll directly
    var shown = progress(), drawn = -1, copyDrawn = -1, raf = 0, visible = true, lastT = 0, frame = 0;
    function tick(now) {
      raf = 0;
      if (++frame % 30 === 0) measureCover();                 // bars can appear/disappear while scrolling
      var target = progress();
      var dt = lastT ? Math.min(64, now - lastT) : 16;
      lastT = now;
      shown += (target - shown) * (1 - Math.exp(-dt / 140));
      if (Math.abs(target - shown) < 0.0004) shown = target;
      if (Math.abs(target - copyDrawn) > 0.0002) { copyDrawn = target; renderCopy(target); }
      if (Math.abs(shown - drawn) > 0.0002) { drawn = shown; renderQuad(shown); }
      if (visible) raf = requestAnimationFrame(tick); else lastT = 0;
    }

    layout();
    if ('ResizeObserver' in window) new ResizeObserver(layout).observe(art);
    window.addEventListener('resize', layout);
    window.addEventListener('load', layout);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) { layout(); if (!raf) raf = requestAnimationFrame(tick); }
      }, { rootMargin: '200px' }).observe(root);
    }
    renderCopy(shown);
    renderQuad(shown);
    raf = requestAnimationFrame(tick);
    return { root: root };
  }

  function boot() {
    document.querySelectorAll('[data-kqg]').forEach(function (root) {
      var cfg = {};
      var el = root.querySelector('script[type="application/json"]');
      if (el) { try { cfg = JSON.parse(el.textContent || '{}'); } catch (e) { cfg = {}; } }
      init(root, cfg);
    });
  }

  window.KiroQuadGloss = { init: init };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
